var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"donutchart",attrs:{"id":"chart"}},[_c('h2',[_vm._v(" This is the chart title ")])])}]

export { render, staticRenderFns }